<template>
  <card title="Title Element" :element="element">
    <e-name :element="element"></e-name>
    <e-text :element="element"></e-text>
    <e-select-file 
    :element="element"
     mode="logos"
     title="Select logo"></e-select-file>
    <e-color :element="element " :full="true"></e-color>
  </card>
</template>

<script>
// import Component from "../component_location"
import Card from "./Card.vue";
import EColor from "./EColor.vue";
import EName from "./EName.vue";
import EText from "./EText.vue";
import EPositionGroup from "./EPositionGroup";
import ESizeGroup from "./ESizeGroup";
import ESelectFile from "./ESelectFile";

export default {
  components: {
    Card,
    EName,
    EText,
    EColor,
    ESelectFile,
  },

  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
